import type { RightDrawerTab } from "./right-drawer-tab-store";

type AgentChatDrawerControls = {
	open: (tab?: RightDrawerTab) => void;
	close: () => void;
	toggle: (tab?: RightDrawerTab) => void;
	setTab: (tab: RightDrawerTab) => void;
};

let controls: AgentChatDrawerControls | null = null;

export function registerAgentChatDrawerControls(
	nextControls: AgentChatDrawerControls,
) {
	controls = nextControls;

	return () => {
		if (controls === nextControls) {
			controls = null;
		}
	};
}

export function openAgentChatDrawer(tab?: RightDrawerTab) {
	controls?.open(tab);
}

export function closeAgentChatDrawer() {
	controls?.close();
}

export function toggleAgentChatDrawer(tab?: RightDrawerTab) {
	controls?.toggle(tab);
}

export function isAgentChatDrawerRegistered() {
	return controls !== null;
}
